// @flow

import React, { type Node, useMemo } from 'react';

import { getSafeGatewayVoucherCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { VoucherNumber, VoucherNumberWrapper } from '../commons/voucher/number';

export function PaynetNumber(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const cashCode = getSafeGatewayVoucherCode(incomingPayment);

  const segments = useMemo(() => cashCode.split(/(.{4})/).filter(Boolean), [cashCode]);

  return (
    <VoucherNumberWrapper>
      {segments.map((segment, index) => (
        <VoucherNumber key={index}>{segment}</VoucherNumber>
      ))}
    </VoucherNumberWrapper>
  );
}
